import { Box } from '@mantine/core';
import { IconPropsType } from './types';
import { useGetColor } from '../hooks';

export const LinkIcon = ({ color, size = 18, sx, ...props }: IconPropsType) => {
  const iconColor = useGetColor(color);
  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      {...props}
    >
      <path
        stroke={color ? iconColor : '#1E1C49'}
        d="M8.57143 11.3571L4.94677 14.9818C4.34056 15.588 4 16.4102 4 17.2675C4 19.0528 5.44723 20.5 7.23249 20.5C8.0898 20.5 8.91199 20.1594 9.5182 19.5532L13.1429 15.9286M15.4286 13.6429L19.0532 10.0182C19.6594 9.41199 20 8.5898 20 7.73249C20 5.94723 18.5528 4.5 16.7675 4.5C15.9102 4.5 15.088 4.84056 14.4818 5.44677L10.8571 9.07143M8.57143 15.9286L15.4286 9.07143"
        strokeWidth="1.5"
      />
    </Box>
  );
};
